import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './home.css';

function Home() {
  return (
    <>
      <Helmet>
        <title>GiveLive - Nền tảng tổ chức Give Away chuyên nghiệp cho Streamer</title>
        <meta name="description" content="GiveLive - Nền tảng tổ chức Give Away trực tuyến miễn phí dành cho Streamer. Tạo phòng phát quà, quay số may mắn với hiệu ứng đẹp mắt và tương tác với viewer một cách dễ dàng." />
        <meta name="keywords" content="giveaway streamer, quay số give away, phát quà stream, công cụ streamer, random picker stream, tổ chức give away" />
        <link rel="canonical" href="https://givelive.sekaiz.net" />
      </Helmet>

      <main className="home-container">
        <section className="hero-section">
          <div className="hero-content">
            <span className="streamer-badge">DÀNH CHO STREAMER</span>
            <h1 className="hero-title">Tạo Give Away Chuyên Nghiệp Cho Stream Của Bạn</h1>
            <p className="hero-subtitle">
              Nền tảng tổ chức Give Away trực tuyến với đầy đủ tính năng cao cấp, 
              giúp các Streamer tạo những phút giây tương tác đáng nhớ cùng viewer
            </p>
            <div className="cta-buttons">
              <Link to="/create-room" className="btn btn-primary btn-lg">
                <i className="fas fa-gift me-2"></i>
                Tạo Give Away Ngay
              </Link>
              <Link to="/demo" className="btn btn-secondary btn-lg">
                <i className="fas fa-play me-2"></i>
                Xem Demo
              </Link>
            </div>
            {/* <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">10K+</span>
                <span className="stat-label">Streamer tin dùng</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">100K+</span>
                <span className="stat-label">Give Away đã tổ chức</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">1M+</span>
                <span className="stat-label">Viewer tham gia</span>
              </div>
            </div> */}
          </div>
        </section>

        <section className="origin-story">
          <div className="origin-content">
            <h2 className="section-title">Câu Chuyện Của Chúng Tôi</h2>
            <div className="origin-text">
              <p>
                GiveLive được tạo ra từ một khoảnh khắc tình cờ khi chúng tôi theo dõi stream của một 
                người anh ở Yên Lãng. Anh ấy đã chia sẻ về những khó khăn khi không tìm được nền tảng 
                Give Away phù hợp để tương tác và tặng quà cho người hâm mộ.
              </p>
              <p>
                Từ đó, chúng tôi nhận ra rằng các streamer Việt Nam đang thiếu một công cụ chuyên nghiệp, 
                dễ sử dụng và được thiết kế riêng cho cộng đồng stream. Đó chính là lý do GiveLive ra đời - 
                để giải quyết nhu cầu thực tế của các streamer Việt.
              </p>
            </div>
          </div>
        </section>

        <section className="why-choose-us">
          <h2 className="section-title">Tại Sao Nên Sử Dụng Give Away?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <i className="fas fa-gift feature-icon"></i>
              <h3 className="feature-title">Tặng Quà Tương Tác</h3>
              <p className="feature-description">
                Give Away là hoạt động tặng quà tương tác giữa streamer và người xem,
                tạo nên những khoảnh khắc vui vẻ và gắn kết cộng đồng.
              </p>
            </div>

            <div className="feature-card">
              <i className="fas fa-users feature-icon"></i>
              <h3 className="feature-title">Xây Dựng Cộng Đồng</h3>
              <p className="feature-description">
                Tạo cơ hội giao lưu và kết nối giữa streamer với viewer, 
                giúp phát triển kênh stream bền vững và chuyên nghiệp.
              </p>
            </div>

            <div className="feature-card">
              <i className="fas fa-chart-line feature-icon"></i>
              <h3 className="feature-title">Tăng Tương Tác</h3>
              <p className="feature-description">
                Tăng lượng tương tác và thời gian xem stream, giúp kênh phát triển
                nhanh chóng và bền vững hơn.
              </p>
            </div>

            <div className="feature-card">
              <i className="fas fa-handshake feature-icon"></i>
              <h3 className="feature-title">Tri Ân Người Xem</h3>
              <p className="feature-description">
                Cách tuyệt vời để cảm ơn và ghi nhận sự ủng hộ của viewer
                đã đồng hành cùng kênh stream của bạn.
              </p>
            </div>

            <div className="feature-card">
              <i className="fas fa-bullhorn feature-icon"></i>
              <h3 className="feature-title">Quảng Bá Hiệu Quả</h3>
              <p className="feature-description">
                Tạo điểm nhấn cho stream, thu hút viewer mới và 
                tăng độ nhận diện thương hiệu cá nhân.
              </p>
            </div>

            <div className="feature-card highlight-card">
              <i className="fas fa-rocket feature-icon"></i>
              <h3 className="feature-title">Phát Triển Kênh</h3>
              <p className="feature-description">
                Công cụ đắc lực giúp phát triển kênh stream, tăng follower
                và xây dựng cộng đồng người xem trung thành.
              </p>
            </div>
          </div>
        </section>

        <section className="how-it-works">
          <h2 className="section-title">Quy Trình Tổ Chức Give Away</h2>
          <div className="steps-container">
            <div className="step-item">
              <div className="step-icon">
                <div className="step-number">1</div>
                <i className="fas fa-home-alt"></i>
              </div>
              <div className="step-content">
                <h3>Tạo Phòng Give Away</h3>
                <p>Chỉ với vài thao tác đơn giản, bạn đã có ngay phòng Give Away 
                với đầy đủ tính năng bảo mật và tùy chỉnh theo ý muốn</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-icon">
                <div className="step-number">2</div>
                <i className="fas fa-share-alt"></i>
              </div>
              <div className="step-content">
                <h3>Chia Sẻ Link Phòng</h3>
                <p>Chia sẻ đường link phòng Give Away cho viewer trong stream 
                để họ có thể tham gia dễ dàng và nhanh chóng</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-icon">
                <div className="step-number">3</div>
                <i className="fas fa-users"></i>
              </div>
              <div className="step-content">
                <h3>Viewer Tham Gia</h3>
                <p>Viewer truy cập vào link và điền thông tin để tham gia.
                Bạn có thể theo dõi số lượng người tham gia trực tiếp</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-icon">
                <div className="step-number">4</div>
                <i className="fas fa-desktop"></i>
              </div>
              <div className="step-content">
                <h3>Stream Màn Hình Quay Số</h3>
                <p>Chia sẻ màn hình quay số may mắn lên stream để tạo
                khoảnh khắc hồi hộp cùng hiệu ứng confetti rực rỡ</p>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="testimonials">
          <h2 className="section-title">Streamer Nói Gì Về Chúng Tôi?</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <i className="fas fa-quote-left"></i>
                <p>GiveLive giúp mình tổ chức Give Away chuyên nghiệp và tiết kiệm thời gian hơn rất nhiều. Viewer rất thích animation quay số!</p>
              </div>
              <div className="testimonial-author">
                <img src="/images/streamer1.jpg" alt="Streamer 1" />
                <div>
                  <h4>Chưa có ai :(</h4>
                  <p>500K Followers</p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="cta-section">
          <h2>Sẵn Sàng Tạo Give Away Chuyên Nghiệp?</h2>
          <p>Nâng tầm stream của bạn với những phút giây tương tác đáng nhớ cùng viewer!</p>
          <div className="cta-buttons">
            <Link to="/create-room" className="btn btn-primary btn-lg">
              <i className="fas fa-rocket me-2"></i>
              Bắt Đầu Ngay - Miễn Phí
            </Link>
            <Link to="/contact" className="btn btn-primary btn-lg">
              <i className="fas fa-headset me-2"></i>
              Liên Hệ Hỗ Trợ
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}

export default Home; 